export const TEST_IDS = {
  TWO_CLICK_APP_INSTALL_MPAC_FOCUSED_TASK: 'two-click-app-install-mpac-focused-task',
  INSTALLABLE_APP_PRIVACY_INFORMATION: 'installable-app-privacy-information',
  TWO_CLICK_APP_INSTALL_ERROR_BOUNDARY: 'two-click-app-install-error-boundary'
};